import React, { useState } from 'react';
import logo from './logo.svg';
import './App.css';
import Navigation from './navigation/Navigation';
import MainScreen from './main/MainScreen';
import Controls from './controls/Controls';
import Intro from './messages/Intro';
import YearCollection from './controls/Years.json';
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;

function App() {

  const [ currentPage, updatePage ] = useState(<Intro />);
  const [ currentPDF1, updatePDF1 ] = useState('/USDB1959/1959Page1.pdf');
  const [ currentPDF2, updatePDF2 ] = useState('/USDB1959/1959Page2.pdf');
  const [ currentYear, updateYear ] = useState('');
  const [ currentCollection, updateCollection ] = useState(YearCollection['1959']);
  const [ screenStatus, toggleScreen ] = useState(true);

  return (
    <div className="App">
      <div className='main'>
        <Navigation updatePage={updatePage} viewNext={updateYear} currentYear={currentYear} toggler={toggleScreen}
          pdf1={updatePDF1} pdf2={updatePDF2} selectedCollection={updateCollection} />
        <MainScreen display={currentPage} currentCollection={currentCollection} currentYear={currentYear} toggler={screenStatus} 
          togglerUpdate={toggleScreen} pdf1={currentPDF1} pdf2={currentPDF2} pdfUpdate1={updatePDF1} 
          pdfUpdate2={updatePDF2} />
      </div> 
    </div>
  );
}

export default App;
